import { render, staticRenderFns } from "./TagInfoModal.vue?vue&type=template&id=397e67d8"
import script from "./TagInfoModal.vue?vue&type=script&lang=js"
export * from "./TagInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports